export default __webpack_public_path__ + "static/media/card-back.ee67de74.png";